import { ColumnsType } from "antd/es/table";
import { ImageCapture } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import { Button } from "@rumbledirect/ui";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const imageCaptureColumns: ColumnsType<ImageCapture> = [
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    render: (text: string, record: ImageCapture) => (
      <Link to={`/image-captures/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Account",
    dataIndex: ["account", "title"],
    key: "account",
    render: (_: any, record: ImageCapture) => record.account?.title,
  },
  {
    title: "Aantal pagina's",
    key: "pagesCount",
    render: (_: any, record: ImageCapture) =>
      record.imageCapturePages?.length ?? 0,
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/image-captures/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
